export default __webpack_public_path__ + "static/media/Belt of the Atlantean.3dbf7ab7.jpg";